/** 自聊沿用服务端私聊存储；空会话只在列表中补入口，不发送占位消息。 */
export function selfChatConversation(userId, conversations, translate) {
  const id = String(userId || "");
  if (!/^[1-9]\d*$/.test(id)) return null;
  const existing = conversations.find((row) => String(row.userId) === id);
  const sessionId = existing?.sessionId || `${id}_${id}`;
  return {
    kind: "LEGACY",
    key: `legacy:${sessionId}`,
    sessionId,
    userId: id,
    messages: [],
    lastMessageId: 0,
    lastTime: null,
    localOnly: true,
    ...existing,
    name: translate("chatWorkbench.selfChat"),
    isSelfChat: true,
    canDelete: false,
    unread: 0,
    isUnread: false,
    lastMessage:
      existing?.lastMessage || translate("chatWorkbench.selfChatHint"),
  };
}

export function chatPinStorageKey(userId) {
  return /^[1-9]\d*$/.test(String(userId || ""))
    ? `xsou.chat.inbox-pins.v1:${userId}`
    : "";
}

export function readChatPins(storage, userId, selfKey) {
  const fallback = selfKey ? [selfKey] : [];
  try {
    const key = chatPinStorageKey(userId);
    if (!key) return [];
    const saved = JSON.parse(storage?.getItem(key) || "null");
    if (saved?.version !== 1 || !Array.isArray(saved.pins)) return fallback;
    return [
      ...new Set(
        saved.pins.filter(
          (key) =>
            typeof key === "string" && key.length > 0 && key.length <= 256
        )
      ),
    ];
  } catch {
    return fallback;
  }
}

export function writeChatPins(storage, userId, pins) {
  try {
    const key = chatPinStorageKey(userId);
    if (!key || !storage) return false;
    storage.setItem(key, JSON.stringify({ version: 1, pins }));
    return true;
  } catch {
    return false;
  }
}

/** 栈顶在数组头；取消只移除目标，其余置顶顺序保持，消息时间不改变栈序。 */
export function toggleChatPin(pins, key) {
  return pins.includes(key)
    ? pins.filter((value) => value !== key)
    : [key, ...pins];
}

export function sortPinnedConversations(conversations, pins, compare) {
  const rank = new Map(pins.map((key, index) => [key, index]));
  return [...conversations].sort((left, right) => {
    const a = rank.get(left.key),
      b = rank.get(right.key);
    if (a !== undefined || b !== undefined)
      return (a ?? pins.length) - (b ?? pins.length);
    return compare(left, right);
  });
}
